import React, { useState, useEffect, useRef } from 'react';
import './Sidebar.css';
import logo from './Psyduck.png';
import { Link } from 'react-router-dom';
import { sidebarItems } from './components/data/SidebarData';
import { PlayerPhoto } from './components/data/PlayerPhoto';
import { TeamIcons, TeamIconsMeta } from './components/data/TeamIcons';
import iconDictionary from './components/data/Icons';
import axiosInstance from './components/backend/axiosInstance';

function Sidebar({ loggedIn }) {
    const [propositions, setPropositions] = useState([]);
    const [playersName, setPlayersName] = useState([]);
    const [teamName, setTeamName] = useState([]);
    const [searchValue, setSearchValue] = useState("");
    const [showDropdown, setShowDropdown] = useState(false);
    const searchRef = useRef(null);
    const [userSidebarConfig, setUserSidebarConfig] = useState(null);
    const [userTeamData, setUserTeamData] = useState([]);
    const [teamGlowColors, setTeamGlowColors] = useState({});


    useEffect(() => {
        axiosInstance
            .get('unique_players/')
            .then(response => {
                setPlayersName(response.data);
            })
            .catch(error => {
                console.error(error);
            });
        axiosInstance
            .get(`unique_teames/`)
            .then(response => {
                setTeamName(response.data);
            })
            .catch(error => {
                console.error(error);
            });
    }, []);


    const getPlayerNameWithoutTeamTag = (fullName) => {
        const parts = fullName.split(' ');
        return parts.slice(1).join(' ').toLowerCase();
    };


    useEffect(() => {
        const handleClickOutside = (e) => {
            if (searchRef.current && !searchRef.current.contains(e.target)) {
                setShowDropdown(false);
            }
        };
        document.addEventListener("mousedown", handleClickOutside);
        return () => document.removeEventListener("mousedown", handleClickOutside);
    }, []);

    const handleInputChange = (value) => {
        setSearchValue(value);
        if (value.trim() === "") {
            setPropositions([]);
            setShowDropdown(false);
            return;
        }

        const filtered = [...playersName, ...teamName].filter((name) =>
            name.toLowerCase().includes(value.toLowerCase())
        );
        setPropositions(filtered);
        setShowDropdown(true);
    };

    const handleSelect = (selectedValue) => {
        const isPlayer = playersName.includes(selectedValue);
        const searchQuery = encodeURIComponent(selectedValue);
        if (isPlayer) {
            window.location.href = `/player/${searchQuery}`;
        } else {
            window.location.href = `/team/${searchQuery}`;
        }
    };

    const mergeSidebar = () => {
        //if (!loggedIn) {
        //    return [
        //         { key: 'login', titleKey: 'Sidebar.login', url: '/login', icon: "Login", section: 'MAIN' }
        //    ];
        //}

        if (!userSidebarConfig) return sidebarItems;

        const map = {};
        userSidebarConfig.forEach(c => {
            map[c.item_key] = c;
        });

        return sidebarItems
            .filter(item => map[item.key]?.visible !== false)
            .map(item => ({
                ...item,
                sort_order: map[item.key]?.sort_order ?? 999
            }))
            .sort((a, b) => a.sort_order - b.sort_order);
    };

    const finalSidebarItems = mergeSidebar();

    function calculateGlowColor(img) {
        const canvas = document.createElement("canvas");
        const ctx = canvas.getContext("2d");

        canvas.width = img.naturalWidth;
        canvas.height = img.naturalHeight;
        ctx.drawImage(img, 0, 0);

        const { data } = ctx.getImageData(0, 0, canvas.width, canvas.height);

        let r = 0, g = 0, b = 0, count = 0;

        for (let i = 0; i < data.length; i += 4) {
            const r0 = data[i];
            const g0 = data[i + 1];
            const b0 = data[i + 2];
            const alpha = data[i + 3];

            const max = Math.max(r0, g0, b0);
            const min = Math.min(r0, g0, b0);

            if (alpha < 150) continue;
            if (max < 40) continue;

            r += r0;
            g += g0;
            b += b0;
            count++;
        }


        if (!count) return "rgba(255,255,255,0.6)";

        return `rgba(${(r / count).toFixed(0)}, ${(g / count).toFixed(0)}, ${(b / count).toFixed(0)}, 0.8)`;
    }


    return (
        <div className="sidebar" id="sidebar">
            <div className="sidebar-header">
                <Link to={"/login"}>
                    <img src={logo} alt="Psyduck" className="sidebar-logo" />
                </Link>
                <div className="search-container" ref={searchRef}>
                    <input
                        type="text"
                        placeholder={`🔍Search...`}
                        className="sidebar-search"
                        value={searchValue}
                        onChange={(e) => handleInputChange(e.target.value)}
                        onFocus={() => propositions.length && setShowDropdown(true)}
                    />

                    {showDropdown && propositions.length > 0 && (
                        <div className="custom-dropdown">
                            {propositions.map((prop, index) => {
                                const isPlayer = playersName.includes(prop);
                                const photo = isPlayer ? PlayerPhoto[getPlayerNameWithoutTeamTag(prop.toLowerCase())] : TeamIcons[prop];
                                return (
                                    <div
                                        key={index}
                                        className="dropdown-item"
                                        onClick={() => handleSelect(prop)}
                                    >
                                        <img
                                            src={photo || PlayerPhoto[1]}
                                            alt={prop}
                                            className="dropdown-image"
                                            style={{ filter: isPlayer ? "none" : TeamIconsMeta[prop]?.dark ? "invert(1)" : "none" }}
                                        />
                                        <span className="dropdown-text" style={{ textWrap: "nowrap" }}>{prop}</span>
                                        <span className="dropdown-type">
                                            {isPlayer ? "Player" : "Team"}
                                        </span>
                                    </div>
                                );
                            })}
                        </div>
                    )}
                </div>
            </div>
            <div className="team-scroll">
                {userTeamData.length > 0 && userTeamData.map((team, idx) => (
                    <Link
                        to={`/team/${team.teamName}`}
                        className="favorite-team"
                        style={{
                            '--glow-color': teamGlowColors[team.teamName] || 'rgba(255,255,255,0.6)'
                        }}
                    >
                        <img
                            src={TeamIcons[team.teamName]}
                            alt={team.teamName}
                            className="favorite-team-icon"
                            crossOrigin="anonymous"
                            style={{
                                '--invert': TeamIconsMeta[team.teamName]?.dark ? 'invert(1)' : 'invert(0)'
                            }}
                            onLoad={(e) => {
                                const color = calculateGlowColor(e.target);
                                setTeamGlowColors(prev => ({
                                    ...prev,
                                    [team.teamName]: color
                                }));
                            }}
                        />
                    </Link>

                ))}
            </div>
            <div className="sidebar-container">
                {['MAIN', 'DRAFTS', 'TOOLS'].map((section) => (
                    <div key={section}>
                        <div className="sidebar-section">
                            <p className="sidebar-section-title">{(section)}</p>
                        </div>

                        {finalSidebarItems
                            .filter(item => item.section === section)
                            .map((item, index) => (
                                <Link key={index} className="sidebar-item" to={item.url}>
                                    <div className="sidebar-item-content">
                                        <img className="small-image-4" src={iconDictionary[item.icon]} alt="" />
                                        <div className="sidebar-item-title">{(item.titleKey)}</div>
                                    </div>
                                </Link>
                            ))}
                    </div>
                ))}
            </div>



            <div className='sidebar-bottom-2'>
                {/*

                    <select
                    className="season-select"
                    value={currentSeason}
                    onChange={(e) => setCurrentSeason(e.target.value)}
                    style={{ width: "80%" }}
                >
                    {seasonOptions.map((season, index) => (
                        <option key={index} value={season.label}>
                            {season.label}
                        </option>
                    ))}
                </select>
                */}
            </div>

            <div className='sidebar-bottom'>
                {localStorage.getItem("team") ? localStorage.getItem("team") : ""}
            </div>

        </div >
    );
}

export default Sidebar;
